import { fbt } from 'fbtee'
import { Plus } from 'lucide-react'
import { DashedButton } from './DashedButton'

interface Props {
  onClick: () => void
}

export function GroupUpsellCard({ onClick }: Props) {
  return (
    <DashedButton onClick={onClick} className="p-4 text-left">
      <div className="flex items-start gap-3">
        <div className="shrink-0 rounded-full bg-primary/10 p-2 text-primary">
          <Plus className="size-5" />
        </div>
        <div className="space-y-1 min-w-0 flex-1">
          <p className="text-base font-semibold">
            {fbt(
              'Make plans with friends',
              'Title of the home page upsell card encouraging guests to create a group',
            )}
          </p>
          <p className="text-sm text-muted-foreground">
            <fbt desc="Body of the home page group upsell card explaining what groups are for">
              Create a group to compare festival picks and decide who's seeing which set together.
            </fbt>
          </p>
        </div>
      </div>
    </DashedButton>
  )
}
